import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { DossierSandboxService } from '@sc/data-access-state-management';
import { AuthService } from '@sc/feature-auth-okta';
import { NavBarComponent } from '@sc/feature-insurer-navbar';
import { Observable } from 'rxjs';
@Component({
  selector: 'sc-insurer-dossiers-search',
  styleUrls: ['./dossiers-search.container.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavBarComponent, RouterOutlet, AsyncPipe],
  template: `
    <header role="banner">
      <sc-insurer-navbar
        (initDossierButtonClickEvent)="onInitDossierButton()"
        [userAllowedToAdminPage]="userAllowedAdmin | async"
        [userAllowedToDashboardPage]="userAllowedDashboard | async"
        [userAllowedToPartnerFitterPage]="userAllowedPartnerFitter | async"
        [userAllowedToDossiersSearchPage]="userAllowedDossiersSearch | async"
      >
      </sc-insurer-navbar>
    </header>
    <main id="sc-container-id" role="main">
      <router-outlet></router-outlet>
    </main>
  `,
})
export class DossiersSearchContainer {
  public userAllowedDashboard: Observable<boolean>;
  public userAllowedAdmin: Observable<boolean>;
  public userAllowedPartnerFitter: Observable<boolean>;
  public userAllowedDossiersSearch: Observable<boolean>;

  constructor(
    private readonly dossierSandboxService: DossierSandboxService,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
    this.userAllowedAdmin = this.authService.userHasInsurerAdminAccess$();
    this.userAllowedDashboard =
      this.authService.userHasInsurerDashboardAccess$();
    this.userAllowedPartnerFitter =
      this.authService.userHasInsurerPartnerFitterAccess$();
    this.userAllowedDossiersSearch =
      this.authService.userHasClaimsListAccess$();
  }

  onInitDossierButton(): void {
    this.initDossierInOtherPages();
  }
  private clearDossier(): void {
    this.authService.clearCurrentDossierId();
    this.dossierSandboxService.clearDossier();
  }
  private clearAndNavigateToCustomerDataPage(): void {
    this.clearDossier();
    this.router
      .navigate(['/declaration/customer-data'])
      .catch((error) => console.error(error));
  }

  private initDossierInOtherPages(): void {
    this.clearAndNavigateToCustomerDataPage();
  }
}
